export default __webpack_public_path__ + "static/media/video1.6584adc4.mp4";